export default "__VITE_ASSET__DwsSLqyi__"